module.exports = __webpack_public_path__ + "media/icons/download-7d547b48.png";